<template>
  <v-dialog width="500px" v-model="flagErrorDialog">
    <template v-slot:activator="{ on }">
      <v-btn icon class="white--text" color="error" v-on="on">
        <v-tooltip top color="secondary">
          <template v-slot:activator="{ on }">
            <v-icon v-on="on">fas fa-flag</v-icon>
          </template>
          <span>Report an error</span>
        </v-tooltip>
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <h3>Report an error</h3>
      </v-card-title>
      <v-divider color="#42a5f5"></v-divider>
      <v-card-text>
        <v-row justify="center" align="center">
          <v-col md="10" cols="12">
            <v-select
              label="Error Type"
              :items="errorTypes"
              item-text="text"
              v-model="errorType"
              return-object
              @input="fault = errorType.fault"
            ></v-select>
          </v-col>
          <v-col md="10" cols="12" v-if="isInternalUser">
            <v-select
              label="Choose a source error"
              :items="fault"
              item-text="text"
              item-value="value"
              v-model="faultCode"
              prepend-icon="fas fa-truck"
              :disabled="!errorType"
            ></v-select>
          </v-col>
          <v-col md="10" cols="12">
            <v-textarea
              counter="140"
              v-model="note"
              label="Tell us more about this error..."
            >
            </v-textarea>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn text color="blue-grey lighten-2" @click="flagErrorDialog=false; note=null; errorType=null; faultCode=null">Cancel</v-btn>
        <v-btn text color="indigo" @click="reportError">report</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
    import axios from 'axios'
    // @vuese
    // Dialog used to flag an error on a specific delivery
    // @group Search
    export default {
        name: "FlagErrorDialog",
        props: {
            tracking: String,
        },
        data() {
            return {
                note: null,
                flagErrorDialog: false,
                errorType: null,
                faultCode: null,
                fault: []
            }
        },
        methods: {
            // @vuese
            // Reports an error with a code_source and note previously filled by the user.
            reportError() {
                const body = {
                  code_source: this.errorType.value,
                  notes: this.note
                };
                if (this.isInternalUser){
                  body.verified = true;
                  body.approved = true;
                  body.code_actual = this.errorType.value;
                  body.fault_code = this.faultCode;
                }
                axios.put(process.env.API_URL + '/errors/' + this.tracking, body)
                    .then((response) => {
                        this.flagErrorDialog = false;
                        this.errorType = null;
                        this.faultCode = null;
                        this.note = null;
                        // @vuese
                        // Event triggered when error was successfully flagged.
                        this.$emit('error-flagged', 'Error has been flagged');
                    })
            },
        },
        computed: {
            isInternalUser() {
                return this.$store.getters['auth/isInternalUser'];
            },
            errorTypes() {
                let errorTypes = [

                    {
                      text: 'Delivered to wrong address',
                      value: 'D',
                      fault: [
                        {text: "Driver", value: 'DR'},
                        {text: "Router", value: 'RP'},
                        {text: "Client", value: 'CL'}
                      ]
                    },
                    {
                      text: 'Instructions Not Followed',
                      value: 'IN',
                      fault: [{text: "Driver", value: 'DR'},
                        {text: "Client", value: 'CL'}]
                    },
                    {text: 'Time Window Error',
                      value: 'TW',
                      fault: [
                        {text: "Driver", value: 'DR'},
                        {text: "Linehaul", value: 'LH'},
                        {text: "Unknown source", value: 'UN'},
                        {text: "Client", value: 'CL'}
                      ]
                    },
                    {
                      text: 'Stolen',
                      value: 'ST',
                      fault: [
                        {text: "Unknown source", value: 'UN'},
                        {text: "Client", value: 'CL'}
                      ]
                    },
                    {
                      text: 'Damaged Box',
                      value: 'DT',
                      fault: [
                        {text: "Driver", value: 'DR'},
                        {text: "Unknown source", value: 'UN'},
                        {text: "Client", value: 'CL'},
                        {text: "Warehouse", value: 'WH'}
                      ]
                    },
                    {
                      text: 'Driver Behaviour',
                      value: 'B',
                      fault: [
                        {text: "Driver", value: 'DR'},
                        {text: "Client", value: 'CL'}
                      ]
                    },
                    {
                      text: 'Property Damage',
                      value: 'P',
                      fault: [
                        {text: "Driver", value: 'DR'},
                        {text: "Client", value: 'CL'}
                      ]
                    },
                    {
                      text: 'Pick-Pack',
                      value: 'PIK',
                      fault: [
                        {text: "Pick-Pack", value: 'PP'},
                        {text: "Client", value: 'CL'}
                      ]
                    },
                ];
                if (this.isInternalUser) {
                    errorTypes.push(
                        {
                          text: 'Mis sort',
                          value: 'MS',
                          fault: [
                            {text: "Driver", value: 'DR'},
                            {text: "Warehouse", value: 'WH'},
                            {text: "Client", value: 'CL'}
                          ]
                        },
                        {
                          text: 'Routing Issue',
                          value: 'R',
                          fault: [
                            {text: "Router", value: 'RP'},
                            {text: "Client", value: 'CL'}
                          ]
                        },
                        {
                          text: 'Technical Issue',
                          value: 'IT',
                          fault: [
                            {text: "Router", value: 'RP'},
                            {text: "Tech", value: 'IT'},
                            {text: "Client", value: 'CL'}
                          ]
                        },
                        {
                          text: 'Natural Disaster',
                          value: 'ND',
                          fault: [
                            {text: "Natural Disaster", value: 'ND'},
                          ]
                        },
                        {
                          text: 'No POD / Insufficient POD',
                          value: 'PO',
                          fault: [
                            {text: "Driver", value: 'DR'},
                            {text: "Tech", value: 'IT'},
                            {text: "Client", value: 'CL'}
                          ]
                        },
                        {
                          text: 'General Error',
                          value: 'GE',
                          fault: [
                            {text: "Driver", value: 'DR'},
                            {text: "Warehouse", value: 'WH'},
                            {text: "Router", value: 'RP'},
                            {text: "Linehaul", value: 'LH'},
                            {text: "Tech", value: 'IT'},
                            {text: "Unknown source", value: 'UN'},
                            {text: "Client", value: 'CL'}
                          ]
                        },
                        {
                          text: 'Unnecessary Returns',
                          value: 'UR',
                          fault: [
                            {text: "Driver", value: 'DR'},
                            {text: "Client", value: 'CL'}
                          ]
                        },
                    );
                }
                return errorTypes;
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/Delivery/Search/FlagErrorDialog.vue